import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux';
import { useNavigate } from "react-router-dom";

import { handleSectionChange } from '../../redux/actions/buyersGuide'
import { getBuyersGuideStageUrl } from '../../helpers/getBuyersGuideStageUrl'

import styles from '../../styles/pages/BuyersGuide.module.css'
import Modal from '../Shared/Modal';

const NextSectionButton = ({ handleSectionChange, buyersGuide: { isLoading, success, specificBuyersGuideData } }) => {
    const navigate = useNavigate();
    const [prompt, setPrompt] = useState({ display: false, message: '' })

    const handleNext = () => {
        let stage = specificBuyersGuideData.curr_stage
        confirmStageChange(stage)
    }

    const setNextStage = (isNew, newStage) => {
        let stage = specificBuyersGuideData.curr_stage

        if (stage < 6) {
            handleSectionChange(stage + 1, specificBuyersGuideData, { loadNew: isNew, stage: newStage, buyers_guide_id: specificBuyersGuideData.buyers_guide_id })
            navigate(`/buyers-guide/${getBuyersGuideStageUrl(stage + 1)}`)
        }
    }

    const confirmStageChange = (stage) => {
        switch (stage) {
            case 4:
                setPrompt({ display: true, heading: 'Finished Editing', message: 'After clicking accept you will not be able to modify product data, until after the manufacturers have had a chance to review.', stage: 2 })
                break;
            case 5:
                setPrompt({ display: true, heading: 'Complete Manufacturer Review', message: 'After clicking accept all manufacturers will lose access to the portals where they can edit their products, you will be able to reopen portal individually.', stage: 3 })
                break;

            default:
                setPrompt({ display: false, heading: '', message: '', stage: 1 })
                setNextStage(false, null)
                break;
        }
    }


    return (
        <>
            <button className={styles.buyers_guide_pdf_button} color="primary" variant="contained" onClick={() => { handleNext() }}>Next</button>

            <Modal
                open={prompt.display}
                setOpen={() => { setPrompt({ ...prompt, display: false }) }}
                component={
                    <div className={styles.buyers_guide_modal_container}>
                        <p className={styles.buyers_guide_modal_header}>{prompt.heading}</p>
                        <p>{prompt.message}</p>
                        <div className={styles.buyers_guide_modal_button_container}>
                            <button className={`button_text button_text_black`} onClick={() => { setPrompt({ ...prompt, display: false }) }}>Disagree</button>
                            <button className={`button_text`} onClick={() => {
                                setNextStage(prompt.display, prompt.stage)
                                setPrompt({ ...prompt, display: false })
                            }} >Agree</button>
                        </div>
                    </div>
                }
            />
        </>
    )
}

const mapStateToProps = state => ({
    buyersGuide: state.buyersGuide
});

export default connect(mapStateToProps, {
    handleSectionChange
}
)(NextSectionButton);
